import React, { useState } from 'react';
import Modal from '../components/Modal';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoadMask from "../Utils/LoadMask/LoadMask";
import NavbarModulo from '../components/NavbarModulo';

import {
    SelectFieldReporte,
    AsyncSelectField
} from "../Utils/renderField/renderField";

function InformesForm(props) {
    const {
        modulo,
        loader,
        reporteMarcas,
        estatus,
        listarMarcas,
        excelMarcas,
        listPais
    } = props;
    
    const [modalListadoMarca, setModalListadoMarca] = useState(false);
    
    let titulo = 'Informes'
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let autoFocus = true;

    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
        
            <div className="container">
                <br/>
                <h4 className='mt-1' style={{ color: "white" }}>Informes</h4>
                <div className="row">
                    <div className="col-xxl-3">
                        <div className="list-group" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => setModalListadoMarca(!modalListadoMarca)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/registro_marca/${id_emp[5]}/informes`}
                                aria-controls="list-home">Listado de marcas</a>
                        </div>
                    </div>
                </div>
                <Modal
                    estado={modalListadoMarca} //Listado de marcas
                    cambiarEstado={setModalListadoMarca}
                    titulo="Listado de marcas"
                    botonCerrar="true"
                    >
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div className='col-12 mb-2'>
                                    <Field
                                        name="producto"
                                        placeholder="Marca..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarMarcas}
                                        msj="Marca"
                                    />
                                </div>
                                <div className='col-12 mb-2'>
                                    {listPais &&
                                        <div className="form-floating">
                                            <Field
                                                name="pais"
                                                options={listPais}
                                                dato={0}
                                                component={SelectFieldReporte}
                                                className="form-select"
                                                msj="Pais"
                                            />
                                        </div>
                                    }
                                </div>
                                <div className='col-6 mb-3'>
                                    {estatus &&
                                        <div className="form-floating">
                                            <Field
                                                autoFocus={autoFocus}
                                                name="status"
                                                options={estatus}
                                                dato={0}
                                                component={SelectFieldReporte}
                                                className="form-select"
                                                msj="Status"
                                            />
                                        </div>
                                    }
                                </div>
                                <div className='mt-2'>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteMarcas}
                                    >
                                        Generar reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelMarcas}
                                    >
                                        Exportar excel
                                    </button>
                                </div>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => setModalListadoMarca(false)}
                                >
                                    Cancelar
                                </button>
                            </Contenido>
                        </LoadMask>
                </Modal>  
            </div>
        </div>
    );
}

InformesForm.propTypes = {
    loader: PropTypes.bool,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormInformesRegistroMarca',
})(InformesForm);


const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;
